import React from 'react'
import { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Tip from './Tip'

const useStyles = makeStyles()(theme => ({
  swiperContainer: {
    width: '100%',
    overflow: 'hidden',

    '& .swiper-pagination': {
      position: 'relative',
      marginTop: theme.spacing(2),
    },

    '& .swiper-pagination-bullet': {
      width: 12,
      height: 12,
      backgroundColor: theme.palette.shades.shade03,
      opacity: 1,
    },

    '& .swiper-pagination-bullet-active': {
      width: 12,
      height: 12,
      backgroundColor: theme.palette.primary.main,
    },
  },
}))

const AUTOPLAY_DELAY = 10000
const TIP_TRANSLATION_KEYS = ['ai360.tip.text1', 'ai360.tip.text2', 'ai360.tip.text3', 'ai360.tip.text4', 'ai360.tip.text5']

const TipsCarousel: React.FC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <Swiper
      slidesPerView="auto"
      autoplay={{ delay: AUTOPLAY_DELAY }}
      pagination={{ clickable: true }}
      loop={true}
      modules={[Pagination, Autoplay]}
      className={classes.swiperContainer}
      spaceBetween={10}
    >
      {TIP_TRANSLATION_KEYS.map((key, index) => (
        <SwiperSlide key={`${key}-${index}`}>
          <Tip text={t(key)} />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default TipsCarousel
